import { IEvaluationTypeService } from "../../service/evaluation/EvaluationTypeService";

export default class GetEvaluationTypesInteractor {
  private evaluationTypeService: IEvaluationTypeService;

  constructor(evaluationTypeService) {
    this.evaluationTypeService = evaluationTypeService;
  }

  async execute() {
    return this.evaluationTypeService.getEvaluationTypes();
  }
}
